import { component } from "preact";
import { css } from "emotion";
import { max } from "../../utils/CssUtils";

const Note = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  semiBold,
  children
}) => {
  const styles = css({
    fontSize: 12,
    fontWeight: semiBold ? 600 : 400,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    [max(breakpoint)]: {
      fontSize: 12,
      marginTop: marginTopMobile,
      marginBottom: marginBottomMobile
    }
  });

  return <p className={styles}>{children}</p>;
};

export default Note;
